import { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Container } from "./CommonStyles";
import { MultiSelectHoriz, MultiSelectHorizProps } from "../form/multi-select-horiz/MultiSelectHoriz";

/**
 * multi-select checkbox field
 */
export const MultiSelectHorizField = forwardRef<any, MultiSelectHorizProps>((props: MultiSelectHorizProps, ref) => {
    const { control } = useFormContext();

    return (
        <Container>
            <Controller
                control={control}
                name={props.id as "dummy"}
                defaultValue={props.value || []}
                render={({ field: { onChange, onBlur, value } }) => (
                    <MultiSelectHoriz {...props} value={value} onChange={onChange} onBlur={onBlur} />
                )}
            />
        </Container>
    );
});
